export default __webpack_public_path__ + "static/assets/syncing-arrow.1058ddbd.png";